import '@ezugi/polyfills.js';
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { isBJSPonURL, isBJVConURL, isUBJonURL } from './store/epics/socket/utils';

const Blackjack = lazy(() => import('./config-bj'));
const BJSP = lazy(() => import('./config-bjsp'));
const BJVC = lazy(() => import('./config-bjvc'));
const UBJ = lazy(() => import('./config-ubj'));

if (isBJSPonURL || isBJVConURL) {
  import('@ezugi/static/animations/coins.gif').then((m) => {
    const src = m.default;
    const image = new Image();

    image.onload = () => null;
    image.onerror = image.onabort = () => null;
    image.src = src;
  });
}

const getGameVariant = () => {
  switch (true) {
  case isBJSPonURL:
    return BJSP;
  case isUBJonURL:
    return UBJ;
  case isBJVConURL:
    return BJVC;
  default:
    return Blackjack;
  }
};

const rootElement = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootElement);

const BJGame = getGameVariant();

root.render(
  <Suspense>
    <BJGame />
  </Suspense>
);
